import { render, staticRenderFns } from "./fbpReportDownload.vue?vue&type=template&id=767ad6af&scoped=true"
import script from "./fbpReportDownload.vue?vue&type=script&lang=js"
export * from "./fbpReportDownload.vue?vue&type=script&lang=js"
import style0 from "./fbpReportDownload.vue?vue&type=style&index=0&id=767ad6af&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767ad6af",
  null
  
)

export default component.exports